<script>
	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const registrationTypeOptions = [
		{
			value: "Individual (Myself)",
			label: "Claim For Yourself: <span style='font-weight: 300'>You are an Aboriginal or Torres Strait Islander person who worked in the Northern Territory between 1 June 1933 and 12 November 1971 for little or no wages.</span>"
		},
		{
			value: "Individual (Spouse)",
			label: "Claim For Your Spouse (husband/wife/partner - married or defacto): <span style='font-weight: 300'>Your spouse was an Aboriginal or Torres Strait Island person who worked in the Northern Territory between 1 June 1933 and 12 November 1971 for little or no wages and has passed away.</span>"
		},
		{
			value: "Individual (Parent)",
			label: "Claim For Your Parent: <span style='font-weight: 300'>Your mother, father or person who adopted you (either legally or under Aboriginal custom) was an Aboriginal or Torres Strait Islander person who worked in the Northern Territory between 1 June 1933 and 12 November 1971 for little or no wages but has passed away.</span>"
		}
	];

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="type-of-claim-details" on:submit={handleSubmit}>
		<FormRowColumn rowClass="justify-content-center confirmation-hide">
			<h4 class="text-center">
				{@html projectSettings.classActionName}
			</h4>
			<h1 class="text-center">Claim Details</h1>
		</FormRowColumn>

		<hr class="primary" />
		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<p>
						If you have more than one claim type to register, you will be able to add another claim at the
						end of this form.
					</p>
				</FormColumn>
			</FormRow>

			<FormRow>
				<FormColumn>
					<RadioGroup
						{disabled}
						required
						cols="12"
						name="registrationType"
						label="What kind of claim are you registering for compensation money?"
						bind:value={$model.registrationType}
						optionList={registrationTypeOptions}
					/>
				</FormColumn>
			</FormRow>
		</div>

		<FormRowColumn rowClass="confirmation-hide">
			<NavigationButtons bind:buttons />
		</FormRowColumn>
	</Form>
</PageSection>

<style>
</style>
